@if (data() != null && data() != undefined) {
  <div class="p-4 md:p-8 max-w-7xl mx-auto">
    <!-- Título y alerta -->
    <div class="flex items-center justify-between mb-2">
      <h1 class="text-xl md:text-2xl font-semibold text-blue-700">
        Detalle de Crédito # {{ data()!.id }}
      </h1>
      @if (data()!.estado === 'PENDIENTE') {
        <div class="flex items-center gap-2 bg-orange-100 text-orange-700 px-3 py-1 rounded">
          <i class="bi bi-exclamation-triangle-fill"></i>
          <span>Deuda Pendiente</span>
        </div>
      } @else if (data()!.estado === 'PENDIENTE_EMISION') {
        <div class="flex flex-col md:flex-row items-center gap-4">
          <div class="flex items-center gap-2 bg-yellow-100 text-yellow-700 px-3 py-1 rounded">
            <i class="bi bi-hourglass-split"></i>
            <span>Pendiente Emisión</span>
          </div>
          <app-button
            label="Emitir"
            icon="bi bi-send"
            variant="warning"
            (onClick)="modal_emitir_venta.set(true)"
          />
        </div>
      } @else if (
        data()!.estado === 'SUNAT_PENDIENTE' ||
        data()!.estado === 'SUNAT_PENDIENTE_ANULACION'
      ) {
        <div class="flex items-center gap-2 bg-blue-100 text-blue-700 px-3 py-1 rounded">
          <i class="bi bi-hourglass-split"></i>
          <span>Procesando SUNAT</span>
        </div>
      } @else if (data()!.estado === 'SUNAT_RECHAZADO') {
        <div class="flex items-center gap-2 bg-red-100 text-red-700 px-3 py-1 rounded">
          <i class="bi bi-x-circle-fill"></i>
          <span>Rechazado SUNAT</span>
        </div>
      } @else {
        <div class="flex items-center gap-2 bg-green-100 text-green-700 px-3 py-1 rounded">
          <i class="bi bi-check-circle-fill"></i>
          <span>Crédito Pagado</span>
        </div>
      }
    </div>
    <div class="text-xs text-gray-500 mb-4">CRÉDITO {{ data()!.id }}</div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
      <!-- Información General -->
      <div class="bg-white rounded-lg shadow p-4 md:col-span-2">
        <h2 class="text-base font-semibold mb-3 text-gray-700">Información General</h2>
        <div class="grid grid-cols-2 md:grid-cols-3 gap-2 text-sm">
          <div>
            <div class="text-gray-400">Cliente</div>
            <div class="font-medium text-gray-800">{{ data()!.cliente.nombre_completo }}</div>
          </div>
          <div>
            <div class="text-gray-400">DNI</div>
            <div class="font-medium text-gray-800">{{ data()!.cliente.dniRuc }}</div>
          </div>
          <div>
            <div class="text-gray-400">Vendedor</div>
            <div class="font-medium text-gray-800">{{ data()!.vendedor.nombre_completo }}</div>
          </div>
          <div>
            <div class="text-gray-400">Fecha</div>
            <div class="font-medium text-gray-800">{{ data()!.fecha }}</div>
          </div>
          <div>
            <div class="text-gray-400">Turno de Caja</div>
            <div class="font-medium text-gray-800">#{{ data()!.vendedor.turnoCaja }}</div>
          </div>
          <div class="col-span-2 md:col-span-3">
            <div class="text-gray-500 text-sm font-medium">Observaciones</div>

            <div class="flex flex-col gap-3">
              <app-textarea
                rows="3"
                placeholder="Agregar observaciones de pago..."
                styleClass="w-full resize-none"
                [(value)]="observaciones_pago"
              />

              <div class="flex justify-center">
                <app-button
                  label="Actualizar"
                  icon="bi bi-cloud-upload"
                  class="w-full sm:w-auto"
                  (onClick)="actualizarObservaciones()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Resumen de Pago -->
      <div class="bg-white rounded-lg shadow p-4 flex flex-col gap-2">
        <h2 class="text-base font-semibold mb-3 text-gray-700">Resumen de Pago</h2>
        <div class="flex justify-between text-sm mb-1">
          <span>Total Crédito:</span>
          <span class="font-semibold">{{ data()!.total | currency: 'PEN' : 'S/.' }}</span>
        </div>
        <div class="flex justify-between text-sm mb-1">
          <span>Total Pagado:</span>
          <span class="font-semibold text-green-600">{{
            totalPagado() | currency: 'PEN' : 'S/.'
          }}</span>
        </div>
        <div class="flex justify-between text-sm mb-2">
          <span>Saldo Pendiente:</span>
          <span class="font-semibold text-red-500">{{
            saldoPendiente() | currency: 'PEN' : 'S/.'
          }}</span>
        </div>
        @if (saldoPendiente() > 0) {
          <div class="bg-orange-50 text-orange-700 rounded p-2 flex items-center gap-2 mb-2">
            <i class="bi bi-exclamation-circle"></i>
            <span
              >Deuda pendiente<br /><span class="text-xs"
                >Falta pagar {{ saldoPendiente() | currency: 'PEN' : 'S/.' }}</span
              ></span
            >
          </div>
        }
        <div class="mb-1">
          <div class="flex justify-between text-xs text-gray-500 mb-1">
            <span>Progreso de Pago</span>
            <span>{{ porcentajeProgreso() | number: '1.0-2' }}%</span>
          </div>
          <div class="w-full bg-gray-200 rounded-full h-2">
            <div class="bg-blue-500 h-2 rounded-full" [style.width.%]="porcentajeProgreso()"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Productos / Ventas asociadas -->
    <div class="bg-white rounded-lg shadow p-4 mb-6">
      <h2 class="text-base font-semibold mb-3 text-gray-700">Productos</h2>
      <div class="overflow-x-auto">
        <table class="min-w-full text-sm">
          <thead>
            <tr class="border-b text-gray-500">
              <th class="py-2 px-2 text-left">Código</th>
              <th class="py-2 px-2 text-left">Producto</th>
              <th class="py-2 px-2 text-center">Cant.</th>
              <th class="py-2 px-2 text-right">P. Unit.</th>
              <th class="py-2 px-2 text-right">Subtotal</th>
            </tr>
          </thead>
          <tbody>
            @for (item of data()!.productos || []; track $index) {
              <tr class="border-b last:border-0">
                <td class="py-2 px-2">{{ item.codigo }}</td>
                <td class="py-2 px-2">{{ item.nombre }}</td>
                <td class="py-2 px-2 text-center">{{ item.cantidad }}</td>
                <td class="py-2 px-2 text-right">
                  {{ item.precio_unitario | currency: 'PEN' : 'S/.' }}
                </td>
                <td class="py-2 px-2 text-right">{{ item.subtotal | currency: 'PEN' : 'S/.' }}</td>
              </tr>
            }
          </tbody>
          <tfoot>
            <tr>
              <td colspan="4" class="text-right font-semibold py-2">Total:</td>
              <td class="text-right font-bold py-2">
                {{ data()!.total | currency: 'PEN' : 'S/.' }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <!-- Historial de Pagos -->
    <div class="bg-white rounded-lg shadow p-4">
      <div class="flex items-center justify-between mb-3">
        <h2 class="text-base font-semibold text-gray-700">Historial de Pagos</h2>
        <app-button
          label="Agregar Pago"
          icon="bi bi-credit-card"
          variant="primary"
          (onClick)="modal_agregar_pago.set(true)"
          [appTooltip]="estadoCaja() ? '' : 'Para agregar pagos, la caja debe estar abierta.'"
          tooltipPosition="bottom"
          [disabled]="saldoPendiente() == 0 || !estadoCaja()"
        />
      </div>
      <div class="overflow-x-auto">
        <table class="min-w-full text-sm">
          <thead>
            <tr class="border-b text-gray-500">
              <th class="py-2 px-2 text-left">#</th>
              <th class="py-2 px-2 text-left">Método de Pago</th>
              <th class="py-2 px-2 text-left">Tipo</th>
              <th class="py-2 px-2 text-right">Monto</th>
            </tr>
          </thead>
          <tbody>
            @for (pago of data()!.pagos || []; track $index) {
              <tr class="border-b last:border-0">
                <td class="py-2 px-2">{{ $index + 1 }}</td>
                <td class="py-2 px-2">{{ pago.tipoPago }}</td>
                <td class="py-2 px-2">{{ pago.transaccion }}</td>
                <td class="py-2 px-2 text-right text-green-600 font-semibold">
                  {{ pago.monto | currency: 'PEN' : 'S/.' }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <app-dialog
    header="Agregar Pago"
    [modal]="true"
    [(visible)]="modal_agregar_pago"
    (onHide)="modal_agregar_pago.set(false)"
    size="md"
  >
    <app-agregar-pago (agregar)="agregarPago($event)" />
  </app-dialog>
  <app-dialog
    header="Emitir Comprobante"
    [modal]="true"
    [(visible)]="modal_emitir_venta"
    (onHide)="modal_emitir_venta.set(false)"
    size="lg"
  >
    <app-emitir-comprobante [showCliente]="false" (emitir)="emitir($event)" />
  </app-dialog>
}
